import React from "react";
import { motion } from "framer-motion";
import { MapPin, Calendar, Users, ArrowRight, Map } from "lucide-react";
import RoutesStack from "./RoutesStack";
import ParticleBackground from "./ParticleBackground";

const Hero = () => {
  return (
    <section className="relative text-gray-900 min-h-[90vh] flex items-center overflow-hidden py-12 md:py-0">
      {/* Interactive Particle Background */}
      <ParticleBackground />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Column: Text Content */}
          <div className="text-center md:text-left">
            <motion.h1
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-gray-900 dark:text-white"
            >
              Explore Verified
              <span className="block text-cycling-orange">Cycling Routes</span>
              <span className="block">Across India</span>
            </motion.h1>

            <motion.p
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-lg md:text-xl lg:text-2xl mb-8 text-gray-600 dark:text-gray-300 max-w-lg mx-auto md:mx-0"
            >
              Discover community-tested routes, join club rides, and ride with
              confidence.
            </motion.p>

            {/* Feature Stats (Now below text on left) */}
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="flex flex-row gap-8 justify-center md:justify-start"
            >
              <div className="flex items-center gap-3">
                <div className="bg-green-100 dark:bg-green-900/30 p-2 rounded-full backdrop-blur-sm">
                  <Map className="w-5 h-5 md:w-6 md:h-6 text-green-600 dark:text-green-400" />
                </div>
                <div className="text-left">
                  <p className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white">
                    12k+
                  </p>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400">
                    verified routes
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="bg-orange-100 dark:bg-orange-900/30 p-2 rounded-full backdrop-blur-sm">
                  <Users className="w-5 h-5 md:w-6 md:h-6 text-orange-600 dark:text-orange-400" />
                </div>
                <div className="text-left">
                  <p className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white">
                    40k
                  </p>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400">
                    riders
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Routes Stack */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="w-full flex justify-center items-center h-[500px] md:h-[600px] relative pointer-events-none md:pointer-events-auto"
          >
            {/* Note: pointer-events-none is removed on md because usually mobile heroes obscure scroll if full screen drag. 
                 But here we explicitly asked for drag. So we keep auto. 
                 Reverting pointer-events logic for simplicity unless user complains. */}
            <div className="pointer-events-auto w-full h-full">
              <RoutesStack />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
